import { render, staticRenderFns } from "./FeedbackFilter.vue?vue&type=template&id=70b0dc28&scoped=true&"
import script from "./FeedbackFilter.vue?vue&type=script&lang=js&"
export * from "./FeedbackFilter.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackFilter.vue?vue&type=style&index=0&id=70b0dc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0dc28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
